import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight, HelpCircle, ChevronDown } from 'lucide-react';

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(0); // Default open the first one

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "What is Roriri ERP?",
      answer: "Roriri ERP is an ERP platform that streamlines student management, attendance, fees, examinations, communication, and reporting."
    },
    {
      question: "How much does Roriri ERP cost?",
      answer: "Plans start from ₹49 per student per year for the Basic package. You can also choose Professional or Custom plans for advanced needs."
    },
    {
      question: "Is there a free trial available?",
      answer: "Yes. Roriri   ERP offers a 30-day free trial with no credit card required, so you can test the system before committing."
    },
    {
      question: "Is my data secure with Roriri ERP?",
      answer: "Roriri ERP uses industry-standard encryption, secure backups, and strict access control to protect your data and maintain privacy."
    },
    {
      question: "Can I migrate from my existing system?",
      answer: "Absolutely. Roriri ERP includes migration assistance to help you move historical data and settings smoothly from your current system."
    },
    {
      question: "Do you provide training and support?",
      answer: "Yes. We offer dedicated onboarding, training, and support via email and chat to help your team succeed."
    },
    {
      question: "Can parents access the system?",
      answer: "Yes. Parent access portals allow guardians to view attendance, homework, fees, and announcements in real time."
    },
    {
      question: "Is Roriri ERP mobile-friendly?",
      answer: "Yes. Roriri ERP provides mobile access through responsive web pages and native Android and iOS apps."
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="section-wrapper" style={{ paddingBottom: '4rem' }}>
        <div className="grid-2">
          <div>
            <span className="section-label">
              <Sparkles size={14} style={{ marginRight: '0.4rem', verticalAlign: 'middle' }} />
              Frequently Asked Questions
            </span>
            <h1 className="hero-gradient-text" style={{ fontSize: '3rem' }}>
              Answers to the most common questions
            </h1>
            <p className="section-desc" style={{ fontSize: '1.2rem', marginBottom: '2.5rem' }}>
              Want to know more about Roriri ERP? Find answers about pricing, security, trials, and support.
            </p>
          </div>

          <div className="hero-mockup-wrapper" style={{ padding: '2rem' }}>
            <div className="premium-card" style={{ padding: '2rem', display: 'flex', gap: '1.5rem', alignItems: 'center', margin: 0 }}>
              <div className="icon-box" style={{ margin: 0, flexShrink: 0 }}>
                <HelpCircle size={32} />
              </div>
              <div>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.25rem' }}>Need Quick Help?</h3>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>Can't find what you need? Reach out directly to our customer support team for answers.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Accordions List Section */}
      <section style={{ borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)', background: 'rgba(241, 245, 249, 0.2)' }}>
        <div className="section-wrapper">
          <div className="faq-list">
            {faqData.map((item, index) => (
              <div 
                key={index} 
                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              >
                <button 
                  className="faq-question" 
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={activeIndex === index}
                >
                  <span>{item.question}</span>
                  <ChevronDown className="faq-icon" size={20} />
                </button>
                <div className="faq-answer">
                  <p style={{ margin: 0, paddingBottom: '0.5rem' }}>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="section-wrapper text-center-wrapper" style={{ padding: '6rem 1.5rem' }}>
        <span className="section-label">Need more help?</span>
        <h2 className="section-title">Still have questions?</h2>
        <p className="section-desc">
          Our support team is here to help. Reach out anytime for assistance.
        </p>
        <Link to="/contact" className="btn btn-primary btn-lg">
          Contact Support
          <ArrowRight size={18} />
        </Link>
      </section>
    </div>
  );
}
